import React from "react";
import CancelSharpIcon from "@mui/icons-material/CancelSharp";
import CircularProgress from "@mui/material/CircularProgress";
import {
  Typography,
  Box,
  Dialog,
  Button,
  Divider,
  useMediaQuery,
  useTheme,
} from "@mui/material";

const ConfirmBox = (props) => {
  const {
    open,
    title,
    content,
    confirmButton,
    setOpenConfirmBox,
    sendOpenLoader,
    Function,
  } = props;

  const theme = useTheme();
  const isXL = useMediaQuery(theme.breakpoints.up("xl"));
  const isMD = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Dialog open={open} fullWidth maxWidth={isXL || isMD ? "sm" : "xl"}>
      <Box sx={{ padding: "0 0 10px 0" }}>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            padding: "10px 20px",
            alignItems: "center",
            boxSizing: "border-box",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Typography
              sx={{
                fontSize: "16px",
                color: "#1A1A1A",
                fontFamily: "Inter,Sans-Serif",
                fontWeight: 500,
              }}
            >
              {title}
            </Typography>
          </Box>
          <CancelSharpIcon
            sx={{ fontSize: 20, opacity: 0.6, cursor: "pointer" }}
            onClick={() => setOpenConfirmBox(false)}
          />
        </Box>
        <Divider sx={{ backgroundColor: "#D5D7E8", opacity: 0.28 }} />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            padding: "10px 20px",
          }}
        >
          <Box>
            <Typography
              sx={{
                color: "#1A1A1A",
                fontWeight: 400,
                fontSize: "14px",
                fontFamily: "Inter,Sans-Serif",
              }}
            >
              {content}
            </Typography>
          </Box>
          <Box
            sx={{ display: "flex", gap: "20px", justifyContent: "flex-end" }}
            mt={6}
          >
            <Button
              className="cancelButton"
              onClick={() => setOpenConfirmBox(false)}
            >
              Cancel
            </Button>
            <Button
              onClick={Function}
              variant="contained"
              className="addButton"
              endIcon={
                sendOpenLoader && (
                  <CircularProgress
                    sx={{ color: "white" }}
                    thickness={6}
                    size={10}
                  />
                )
              }
            >
              {confirmButton}
            </Button>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default ConfirmBox;
